import * as ConnectionQueries from '../../queries/connection';
import { makeApolloClient, logError } from '../util';

export const FETCH_EVENT_CONNECTION = 'FETCH_EVENT_CONNECTION';
export const UPDATE_EVENT_CONNECTION = 'UPDATE_EVENT_CONNECTION';
export const CREATE_EVENT_CONNECTION = 'CREATE_EVENT_CONNECTION';
export const FETCH_EVENT_CONNECTIONS = 'FETCH_EVENT_CONNECTIONS';
export const DELETE_CONNECTION = 'DELETE_CONNECTION';

const fetchEventConnection = (eventConnection, from = '') => ({
	type: FETCH_EVENT_CONNECTION,
	from,
	eventConnection,
});

export const thunkFetchEventConnection = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventConnection } = await client.request(ConnectionQueries.EVENT_CONNECTION, {
			event_id: eventID,
		});
		dispatch(fetchEventConnection(eventConnection, from));
	} catch (error) {
		logError(error, 'connection.actions.thunkFetchEventConnection');
	}
};

const fetchEventConnections = (eventConnections, from = '') => ({
	type: FETCH_EVENT_CONNECTIONS,
	from,
	eventConnections,
});

export const thunkFetchEventConnections = (
	{ event_id, attendee_id, offset, items_per_page },
	from
) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventConnections } = await client.request(ConnectionQueries.EVENT_CONNECTIONS, {
			event_id,
			attendee_id,
			offset,
			items_per_page,
		});
		dispatch(fetchEventConnections(eventConnections, from));
	} catch (error) {
		logError(error, 'connection.actions.thunkFetchEventConnections');
	}
};

export const updateEventConnection = eventConnection => ({
	type: UPDATE_EVENT_CONNECTION,
	eventConnection,
});

export const createEventConnection = eventConnection => ({
	type: CREATE_EVENT_CONNECTION,
	eventConnection,
});

export const deleteConnection = connectionID => ({
	type: DELETE_CONNECTION,
	connectionID,
});
